<template>
  <div v-if="initPage">
    <div v-loading="true" class="loading"></div>
  </div>
  <div v-else>
    <Errors typeForm="page"></Errors>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Errors from "@/components/Errors";
import { checkAccess } from "@/helpers/access";

export default {
  name: "errorpayments",
  components: {
    Errors
  },
  computed: {
    ...mapGetters(["initPage"]) // , "params" "subscribers", "subscriberCardModal",
  },
  beforeCreate() {
    if (!checkAccess(44) && !checkAccess(45)) {
      this.$router.push("/");
    }
  },
  async created() {
    document.title = this.$t("errorPayments.title");
    await this.getParams({
      account: "1",
      gfirme: "1",
      gkindpay: "1",
      gusers: "1",
      codepay: "1",
      guserspackedit: "1",
      street: "1",
      gregion: "1",
      statuspay: "1",
      gservice: "1",
      gzone: "1",
      gcurrency: "1"
    });

    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    // this.clearSubscribers();
    // очистка состояния ???

    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    ...mapActions(["getParams"])
  }
};
</script>
